import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { createUseStyles } from '../../../../../../../theming';

interface Props {
  open: boolean;
  onClose: () => void;
  onValidate: () => void;
}

const useStyles = createUseStyles({
  formField: {
    marginTop: '15px !important',
  },
  error: {
    color: '#f44336',
  },
});

const UpdateTicketModal: FC<Props> = ({ open, onValidate, onClose }) => {
  const [formError, setFormError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleValidate = async () => {
    try {
      setLoading(true);

      await onValidate();

      setLoading(false);
      setFormError(undefined);
      onClose();
    } catch (e) {
      setLoading(false);
      setFormError(e.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Mise à jour du ticket</DialogTitle>

      <DialogContent>
        Vous êtes sur le point de modifier le ticket.
        <br />
        Êtes-vous sûr ?<br />
        {formError && <p className={classes.error}>{formError}</p>}
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' onClick={handleValidate} color='primary'>
          {loading && <CircularProgress color='primary' size={15} />} Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateTicketModal;
